import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="bg-slate-900 text-white py-16" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          <div className="col-span-1 lg:col-span-2">
            <Link to="/" className="flex items-center gap-2.5 mb-4">
              <div className="w-10 h-10 bg-white rounded-xl flex items-center justify-center p-1">
                <img src="/brand/lq-symbol.png" alt="LearnQuanta" className="w-full h-full object-contain" />
              </div>
              <span className="font-bold text-xl">LearnQuanta</span>
            </Link>
            <p className="text-slate-400 mb-4 max-w-sm">
              Empowering professionals with industry-leading technology training. 
              Live, instructor-led programs for ERP, Cloud, and Business Software.
            </p>
            <p className="text-slate-400">info@learnquanta.com</p>
            <p className="text-slate-400">+46 760 085 362</p>
          </div>

          <div>
            <h4 className="font-semibold text-lg mb-4">ERP Programs</h4>
            <ul className="space-y-2">
              <li><Link to="/programs/ifs" className="text-slate-400 hover:text-white">IFS Training</Link></li>
              <li><Link to="/programs/odoo" className="text-slate-400 hover:text-white">Odoo Training</Link></li>
              <li><Link to="/programs/oracle" className="text-slate-400 hover:text-white">Oracle Training</Link></li>
              <li><Link to="/programs/netsuite" className="text-slate-400 hover:text-white">NetSuite Training</Link></li>
              <li><Link to="/programs/infor" className="text-slate-400 hover:text-white">Infor Training</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-lg mb-4">Coming Soon</h4>
            <ul className="space-y-2">
              <li><span className="text-slate-500">AI-900, AI-102 (Azure)</span></li>
              <li><span className="text-slate-500">AWS ML Specialty</span></li>
              <li><span className="text-slate-500">TensorFlow Developer</span></li>
              <li><span className="text-slate-500">AWS & Azure Cloud</span></li>
              <li><span className="text-slate-500">Salesforce & ServiceNow</span></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-lg mb-4">Company</h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-slate-400 hover:text-white">About Us</Link></li>
              <li><Link to="/training-model" className="text-slate-400 hover:text-white">Training Model</Link></li>
              <li><Link to="/certification" className="text-slate-400 hover:text-white">Certification</Link></li>
              <li><Link to="/pricing" className="text-slate-400 hover:text-white">Pricing</Link></li>
              <li><Link to="/contact" className="text-slate-400 hover:text-white">Contact</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-slate-800 text-center text-slate-500 text-sm">
          <p>© {new Date().getFullYear()} LearnQuanta. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
